"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Inline = _styledComponents.default.div.withConfig({
  displayName: "CheckBox__Inline",
  componentId: "sc-1m9coxg-0"
})(["display:flex;align-items:center;"]);

const CheckBox = ({
  className,
  label,
  children,
  ...rest
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, label ? /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", _extends({
  type: "checkbox"
}, rest)), /*#__PURE__*/_react.default.createElement("span", null, label)) : /*#__PURE__*/_react.default.createElement(Inline, null, /*#__PURE__*/_react.default.createElement("input", _extends({
  type: "checkbox"
}, rest)), /*#__PURE__*/_react.default.createElement("span", null, children)));

var _default = (0, _styledComponents.default)(CheckBox).withConfig({
  displayName: "CheckBox",
  componentId: "sc-1m9coxg-1"
})(["label{cursor:pointer;display:flex;align-items:center;}input{cursor:pointer;min-height:24px;max-height:24px;min-width:24px;max-width:24px;margin-right:8px;}"]);

exports.default = _default;